module.exports = __webpack_public_path__ + "static/img/AnLe_Banner.e53dc227.jpg";